<div class="p-4 pt-0" style="height: 95%">
  <h3 class="text-lg">{{pickDayText}}</h3>
  <mot-date-picker id="day-select" [formControl]="dayFormControl" [label]="dayText" [minDate]="minDate"
    [maxDate]="maxDate" [displayErrors]="false" class="text-start w-full" style="width: 50%" />

    @if (stopsChanged) {
      <span class="text-sm text-red-500 block mt-1">{{stopsChangedText}}</span>
    }

    @if (dailyCalendar && dailyCalendar.length) {
      <mot-table [dataSource]="dailyCalendar" [config]="config"
        [emptyAlt]="emptyTableAltText" [scrollToIndex]="closestIndex"
        class="h-3/4 print-table" style="display: block; margin-top: 1rem; min-height: 400px; overflow-y: visible;" />
    }
    @if (!dailyCalendar || dailyCalendar.length === 0) {
      <div
        class="w-full flex flex-col gap-2 items-center justify-center py-4">
        <p class="m-0">{{lineNotActiveOnSelectedDayText}}</p>
        <p class="m-0">{{getNextDayOfServiceText()}}</p>
      </div>
    }
  </div>
  @if (isLoadingCalendarData) {
    <app-loader />
  }